import type { RadioChangeEvent } from 'antd';
import { Radio } from 'antd';
import { color } from 'asserts/styles/colors';
import styled from 'styled-components';

interface RadioButtonProps {
  value: any;
  options: any;
  onChange: (value: number) => void;
}

const RadioButton = ({ value, options, onChange }: RadioButtonProps) => {
  const handleChange = (e: RadioChangeEvent) => {
    const selectedValue = e.target.value;
    onChange(selectedValue);
  };

  return (
    <Wrapper>
      <Radio.Group onChange={handleChange} value={value} className="radio-custom">
        {options.map((option: any) => (
          <Radio key={option.value} value={option.value}>
            {option.label}
          </Radio>
        ))}
      </Radio.Group>
    </Wrapper>
  );
};

export default RadioButton;

const Wrapper = styled.div`
  .ant-radio-group .ant-radio-wrapper {
    .ant-radio-inner {
      border-color: ${color.gray500};
      border-width: 2px;
      background-color: inherit;
    }

    .ant-radio-inner::after {
      background-color: #0c0c0c;
      width: 20px;
      height: 20px;
      margin-block-start: -10px;
      margin-inline-start: -10px;
    }

    .ant-radio-wrapper .ant-radio:hover,
    .ant-radio.ant-radio-checked:hover::after {
      border: inherit;
      box-shadow: 0px 0px 0px 3px ${color.opacityBlack01};
      outline: none;
      background-color: ${color.opacityBlack01};
    }
  }
  .ant-radio-input:focus + .ant-radio-inner {
    box-shadow: 0px 0px 0px 3px ${color.opacityBlack01};
    outline: none;
  }
`;
